import { useMemo, useState, useCallback } from "react";
import Button from "react-bootstrap/Button";
import Searchable from "react-searchable-dropdown";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import {
  EditDayPrivateTour,
  resetOffers,
} from "../../Redux/offerReducer/offerSlice";
import { Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { resetReservations } from "../../Redux/reserveReducer/reserveSlice";

// Reusable Component
const DayTourRow = ({
  data,
  date,
  index,
  hotel_id,
  accommodations,
  onRoomCategoryChange,
  onExtrabedChhange,
}) => {
  const formatPrice = (price) => Math.floor(price);
  const [selectedSeason, setSelectedSeason] = useState();
  // Get dropdown rooms categories
  const dropdowmRoomsCategories = useMemo(() => {
    const filterHotels = accommodations.find((hotel) => {
      return hotel.id == hotel_id;
    });

    if (filterHotels) {
      // Map filtered hotels to dropdown options
      return filterHotels.accommodation_rooms_categories.map((item) => ({
        value: item.id,
        label: item.room_category.category,
      }));
    }

    return [];
  }, [accommodations, hotel_id]); // Dependency array

  const handelRoomCategoryDropdown = (value) => {
    const filterHotels = accommodations.find((hotel) => hotel.id === hotel_id);
    if (!filterHotels) return; // Handle missing hotel

    const filter_by_date = filterHotels?.seasons.find((item) => {
      const fromDateItem = new Date(item.start_date);
      const toDateItem = new Date(item.end_date);
      const datex = new Date(date);
      return fromDateItem <= datex && toDateItem > datex;
    });

    if (!filter_by_date) {
      console.error("No matching season found");
      return; // Handle missing season
    }

    const RoomPrice = filterHotels.room_prices.find((item) => {
      return (
        item.accommodation_room_category_id === value &&
        item.season_id === filter_by_date.id
      );
    });

    if (!RoomPrice) {
      console.error("Room price not found");
      return; // Handle missing room price
    }

    setSelectedSeason(filter_by_date);
    onRoomCategoryChange(index, value, formatPrice(RoomPrice.price));
  };

  // handel change checkbox extrabed
  const handleExtrabedPrice = useCallback(
    (checked) => {
      const extrabed_price = checked ? selectedSeason.extra_bed : 0;
      onExtrabedChhange(index, checked, formatPrice(extrabed_price));
    },
    [index, selectedSeason]
  );

  return (
    <Row className="row-sm">
      <Col md={6} lg={6} xl={6} className="p-1">
        <Form.Group className=" select2-sm ">
          <div className="d-flex  ">
            <Searchable
              className="form-control select2 z-index-200 pos-absolute"
              value={data?.room_category_id}
              placeholder={"Room Category"} // by default "Search"
              notFoundText="No result found" // by default "No result found"
              noInput
              options={dropdowmRoomsCategories}
              onSelect={(value) => {
                handelRoomCategoryDropdown(value);
              }}
              listMaxHeight={140} //by default 140
            />
          </div>
        </Form.Group>
      </Col>
      <Col md={4} lg={4} xl={4} className="p-1 d-flex flex-column">
        <label className=" custom-control custom-checkbox  flex-grow-1 ">
          <input
            type="checkbox"
            className="custom-control-input"
            name="example-checkbox1"
            value="option1"
            defaultChecked={data?.extra_bed == 1 ? true : false}
            onChange={(e) => handleExtrabedPrice(e.target.checked)}
            disabled={selectedSeason ? false : true}
          />
          <span className="custom-control-label custom-control-label-md  tx-16">
            Extra Bed
          </span>
        </label>
      </Col>
      <Col md={2} lg={2} xl={2} className="p-1">
        <span className="d-flex justify-content-end">
          ${data?.room_price + data?.extrabed_price}
        </span>
      </Col>
    </Row>
  );
};

// Main Component
function ModelEditDayTour({
  Data,
  show,
  handelClose,
  destination,
  day_tours,
  accommodations,
  reserved,
}) {
  const dispatch = useDispatch();
  console.log(Data);

  const [itemData, setItemData] = useState(Data.data);

  // Dropdown Cities
  const dropdownCities = useMemo(() => {
    if (!destination) {
      return [];
    }
    return destination?.cities.map((item) => ({
      value: item.id,
      label: item.city_en,
    }));
  }, [destination]);

  //Get the Tours dropdown
  const dropdownTours = useMemo(() => {
    if (!day_tours || itemData?.city_id == 0) {
      return [];
    }
    // Filter tours by cityId
    const toursFilteredByCity = day_tours.filter((tour) => {
      return tour.city_id === itemData?.city_id;
    });
    return toursFilteredByCity.map((item) => ({
      value: item.id,
      label: item.title_en,
    }));
  }, [day_tours, itemData]);

  // filter all hotels by  & City_id
  const AccommodationDropdown = useMemo(() => {
    // Filter all hotels by TypeOfAccommodation_id & City_id
    const filterHotels = accommodations.filter((hotel) => {
      return hotel.city_id === itemData?.city_id && hotel.share == 1;
    });

    // Map filtered hotels to dropdown options
    return filterHotels.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }, [accommodations, itemData]);

  const close = () => {
    handelClose();
  };

  // Generic handler for input changes
  const handleInputChange = (field, value) => {
    setItemData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // handle Accommodation changes
  const handleAccommodationChange = (value) => {
    setItemData((prev) => ({
      ...prev,
      accommodation_id: value,
      r_room_categories: [],
      number_of_rooms: 0,
    }));
  };
  //handel chande tourguide check box
  const handleTourguidePrice = (checked) => {
    if (checked) {
      const price = destination.tourguide_price.price;
      setItemData((prevData) => ({
        ...prevData,
        tourguide: true,
        tourguide_price: price,
      }));
    } else {
      setItemData((prevData) => ({
        ...prevData,
        tourguide: false,
        tourguide_price: 0,
      }));
    }
  };

  function inc() {
    setItemData((prevData) => {
      const newCategory = {
        room_category_id: null, // Replace with default or cloned values
        room_price: 0,
        extrabed_price: 0,
        extra_bed: 0,
      };

      return {
        ...prevData,
        number_of_rooms: itemData.number_of_rooms + 1,
        r_room_categories: [...prevData.r_room_categories, newCategory],
      };
    });
  }

  function dec() {
    setItemData((prevData) => {
      if (prevData.r_room_categories.length > 0) {
        const updatedCategories = prevData.r_room_categories.slice(0, -1); // Remove the last object
        return {
          ...prevData,
          number_of_rooms: itemData.number_of_rooms - 1,
          r_room_categories: updatedCategories,
        };
      }
      return prevData; // Return unchanged data if the array is already empty
    });
  }

  // Callback to handle room category changes
  const handleRoomCategoryChange = (index, id, price) => {
    setItemData((prevData) => {
      const updatedCategories = [...prevData.r_room_categories];
      updatedCategories[index] = {
        ...updatedCategories[index],
        room_category_id: id,
        room_price: price,
      };
      return {
        ...prevData,
        r_room_categories: updatedCategories,
      };
    });
  };

  // Callback to handle room category changes
  const handleExtrabedChange = (index, value, price) => {
    setItemData((prevData) => {
      const updatedCategories = [...prevData.r_room_categories];
      updatedCategories[index] = {
        ...updatedCategories[index],
        extra_bed: value,
        extrabed_price: price,
      };
      return {
        ...prevData,
        r_room_categories: updatedCategories,
      };
    });
  };

  const validateRoomCategories = () => {
    const hasEmptyCategory = itemData.r_room_categories.some(
      (category) => !category.room_category_id
    );

    if (hasEmptyCategory) {
      toast.error("Room Category is Requierd");
      return false;
    }

    return true;
  };
  const submitData = () => {
    if (validateRoomCategories()) {
      dispatch(EditDayPrivateTour(itemData));
      if (reserved == 1) {
        dispatch(resetReservations());
      } else if (reserved == 0) {
        dispatch(resetOffers());
      }

      handelClose();
    }
  };
  return (
    <>
      <Modal show={show} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>
            <span className="bg-success p-1 rounded me-1 tx-10">
              {Data.index}
            </span>
            <span className="bg-primary p-1 rounded me-2 text-nowrap tx-10">
              {itemData?.date || "Loading..."}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Row className="row-sm ">
              <Col md={12} lg={12} xl={12} className="p-1">
                <label className="">City :</label>
                <Form.Group className="form-group select2-md mb-3 ">
                  <Searchable
                    className="form-control select2"
                    value={itemData?.city_id || ""}
                    placeholder={"Choose City"}
                    notFoundText="No result found" // by default "No result found"
                    noInput
                    options={dropdownCities}
                    onSelect={(value) => handleInputChange("city_id", value)}
                    listMaxHeight={170} //by default 140
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="row-sm ">
              <Col md={12} lg={12} xl={12} className="p-1">
                <label className="">Tour :</label>
                <Form.Group className="form-group select2-md mb-3 ">
                  <Searchable
                    className="form-control select2"
                    value={itemData?.day_tour_id || ""}
                    placeholder={"Choose Tour Title"}
                    notFoundText="No result found" // by default "No result found"
                    noInput
                    options={dropdownTours}
                    onSelect={(value) =>
                      handleInputChange("day_tour_id", value)
                    }
                    listMaxHeight={170} //by default 140
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="row-sm ">
              <Col md={5} lg={5} xl={5} className="p-1">
                <label className=" custom-control custom-checkbox  flex-grow-1 mb-3 ">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    name="example-checkbox1"
                    value="option1"
                    defaultChecked={
                      itemData?.with_accommodation == 1 ? true : false
                    }
                    onChange={(e) => {
                      const isChecked = e.target.checked ? 1 : 0;
                      setItemData((prevData) => ({
                        ...prevData,
                        with_accommodation: isChecked, // Update accommodation state
                      }));
                    }}
                  />
                  <span className="custom-control-label custom-control-label-md text-nowrap tx-14">
                    Accommodation
                  </span>
                </label>
              </Col>
              <Col md={5} lg={5} xl={5} className="p-1">
                <label className=" custom-control custom-checkbox  flex-grow-1 mb-3">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    name="example-checkbox1"
                    value="option1"
                    defaultChecked={itemData?.tourguide == 1 ? true : false}
                    onChange={(e) => handleTourguidePrice(e.target.checked)}
                  />
                  <span className="custom-control-label custom-control-label-md text-nowrap tx-14">
                    Tourguide
                  </span>
                </label>
              </Col>
              <Col md={2} lg={2} xl={2} className="p-1">
                <span className="d-flex justify-content-end">
                  ${itemData?.tourguide_price || 0}
                </span>
              </Col>
            </Row>

            {itemData?.with_accommodation == 1 && (
              <>
                <Row className="row-sm ">
                  <Col md={7} lg={7} xl={7} className="p-1">
                    <label className="">Accommodation:</label>
                    <Form.Group className="form-group select2-md mb-3 ">
                      <Searchable
                        className="form-control select2"
                        value={itemData?.accommodation_id}
                        placeholder={"Choose Tour Title"}
                        notFoundText="No result found" // by default "No result found"
                        noInput
                        options={AccommodationDropdown}
                        onSelect={(value) => handleAccommodationChange(value)}
                        listMaxHeight={170} //by default 140
                      />
                    </Form.Group>
                  </Col>
                  <Col md={5} lg={5} xl={5} className="p-1 d-flex flex-column">
                    <div className="mt-auto">
                      <div className="handle-counter mb-3" id="handleCounter">
                        <Button
                          variant="light"
                          className="counter-minus"
                          onClick={dec}
                        >
                          -
                        </Button>
                        <input
                          type="text"
                          value={itemData?.number_of_rooms || 0}
                          onChange={() => {}}
                        />
                        <Button
                          variant="light"
                          className="counter-plus"
                          onClick={inc}
                        >
                          +
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
                {itemData?.r_room_categories.map((item, index) => (
                  <DayTourRow
                    key={index}
                    data={item}
                    index={index}
                    hotel_id={itemData?.accommodation_id}
                    accommodations={accommodations}
                    onRoomCategoryChange={handleRoomCategoryChange}
                    onExtrabedChhange={handleExtrabedChange}
                    date={itemData.date}
                  />
                ))}
              </>
            )}

            {/* <div>{formik.touched.country && formik.errors.country}</div> */}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handelClose}>
            Close
          </Button>
          <Button variant="primary" onClick={submitData}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModelEditDayTour;
